const actions = {
  SET_STATE: "connection/SET_STATE",
  LIST: "connection/LIST",
  CREATE: "connection/CREATE",
  DETAIL: "connection/DETAIL",
  UPDATE: "connection/UPDATE",
  DELETE: "connection/DELETE",
};

export default actions;
